import { render } from "./SelectPayment.vue?vue&type=template&id=6f564be3&ts=true"
import script from "./SelectPayment.vue?vue&type=script&lang=ts"
export * from "./SelectPayment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__